export default function () {
    return {
        vacancy: null,
    };
}
